module.exports = __webpack_public_path__ + "public/files/img/bus.6b0dbc9d.gif";